import React from "react";
import { TextField, Tooltip } from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";

type Props = TextFieldProps & {
  key?: string;
  tooltip?: string;
};

export default function TrTextField({
  required = false,
  label,
  name,
  value,
  type,
  tooltip,
  className,
  onChange,
  helperText,
  onBlur,
  InputProps,
  key,
  error = false,
  disabled,
  fullWidth,
  inputRef
}: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(e);
  };

  const textField = () => {
    return (
      <TextField
        disabled={disabled}
        required={required}
        label={label}
        name={name}
        value={value}
        type={type}
        className={className}
        helperText={helperText}
        onChange={handleChange}
        onBlur={onBlur}
        variant={"outlined"}
        InputProps={InputProps}
        autoComplete={"off"}
        id={name && key ? name + key : ""}
        error={error}
        fullWidth={fullWidth}
        inputRef={inputRef}
      />
    );
  };

  return tooltip ? (
    <Tooltip title={tooltip} placement="top">
      {textField()}
    </Tooltip>
  ) : (
    <>{textField()}</>
  );
}
